// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#aw--c #aw-sl .pw-continue-play-button[data-v-23ba03c4]:hover{opacity:1!important}", ""]);
// Exports
module.exports = exports;
